import React, { useEffect, useState } from 'react'
import { Button, Card, Form, Modal } from 'react-bootstrap'
import callapi from '../../helpers/callapi'
import AnnouncementList from './AnnouncementList'

export default function Announcement() {
  const [show, setShow] = useState(false)
  const [currentPage, setCurrentPage] = useState(1)
  const [announcements, setAnnouncements] = useState([])
  async function fetchAnnounces(query) {
    let options = { url: '/announcements' }
    if (query) options.query = query
    const response = await callapi(options)
    if (response.errors) {
      alert(response.errors.message)
      return
    }
    setAnnouncements(response.data)
  }
  function handleCreate() {
    const elMessageTextarea = document.querySelector('#message')
    const elLink = document.querySelector('#link')
    const message = elMessageTextarea.value
    const link = elLink.value
    if (message) {
      callapi({ url: '/announcements', method: 'post', body: { message: message, link: link } })
        .then((res) => {
          fetchAnnounces()
        })
        .catch((err) => {
          fetchAnnounces()
        })
      setShow(false)
    }
  }
  function handleOnDelete(id) {
    console.log(id)
    fetchAnnounces()
  }
  function handleOnSend(id) {
    console.log(id)
  }
  function handlePrevious() {
    // fetchAnnounces(pageOptions)
    if (currentPage > 1) setCurrentPage(currentPage - 1)
  }
  function handleNext() {
    // const id = announcements[announcements.length -1].id
    // const pageOptions = {startAfter:id}
    //fetchAnnounces(pageOptions)
    setCurrentPage(currentPage + 1)
  }
  useEffect(() => {
    fetchAnnounces()
    return () => {}
  }, [])
  return (
    <>
      <Modal show={show} onHide={() => setShow(false)} centered>
        <Modal.Header>ข้อความ</Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Control
              id="message"
              as="textarea"
              placeholder="ข้อความ"
              style={{ height: '120px', marginBottom: '8px' }}
            />
            <Form.Control id="link" placeholder="ใส่ลิงค์" />
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-danger" size="sm" style={{ border: 'white' }} onClick={() => setShow(false)}>
            ยกเลิก
          </Button>
          <Button variant="primary" size="sm" onClick={handleCreate}>
            ส่งข้อความ
          </Button>
        </Modal.Footer>
      </Modal>
      <Card>
        <Card.Header>
          <Card.Title>Announcement</Card.Title>
          <Button size="sm" onClick={() => setShow(true)}>
            สร้าง
          </Button>
        </Card.Header>
        <Card.Body>
          <Card.Title>รายการข้อความ</Card.Title>
          <Card.Subtitle>รายละเอียดข้อความ</Card.Subtitle>
          <div className="pt-3 pb-3">
            <AnnouncementList announcements={announcements} onDelete={handleOnDelete} onSend={handleOnSend} />
          </div>
        </Card.Body>
        {/* <Card.Footer>
                    {currentPage > 1 && <Button onClick={()=>handlePrevious()} variant="primary light" size="sm">{`< ย้อนกลับ`}</Button>}
                    <Button variant="primary light" size="sm" className="ml-2 mr-2">{currentPage}</Button>
                    {announcements.length === 2 && <Button onClick={()=>handleNext()} variant="primary light" size="sm">{`ถัดไป >`}</Button>}
                </Card.Footer> */}
      </Card>
    </>
  )
}
